import type { PromoteCandidate } from "./iam-api";

/** One search answer, tied to the exact query it answers. */
export type CandidateSearch =
  | { q: string; users: PromoteCandidate[] }
  | { q: string; error: string };

export type CandidateView =
  | { kind: "idle" }
  | { kind: "searching" }
  | { kind: "error"; message: string }
  | { kind: "empty" }
  | { kind: "rows"; users: PromoteCandidate[] };

/**
 * What the promote dialog may show for the text in the box. Rows appear only
 * when they answer that exact text: while a newer query is in flight the old
 * rows are hidden, so a click can never pick a person from an older search.
 */
export const candidateView = (search: CandidateSearch | null, query: string): CandidateView => {
  const q = query.trim();
  if (q.length < 2) return { kind: "idle" };
  if (!search || search.q !== q) return { kind: "searching" };
  if ("error" in search) return { kind: "error", message: search.error };
  return search.users.length ? { kind: "rows", users: search.users } : { kind: "empty" };
};
